export default __webpack_public_path__ + "media/offline-counselling.7f02cafd.png";